import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import { bgLinearGradient } from "@/app/types/ui";
import { HeadingTwo } from "@/components/ui/typography/HeadingTwo";
import { Paragraph } from "@/components/ui/typography/Paragraph";
import { HeadingOne } from "@/components/ui/typography/HeadingOne";
import { MimiatHorizontalLogo } from "@/components/shared/MimiatHorizonalLogo";
import { EmailInput } from "@/components/reset-password/EmailInput";

import forgotPasswordImg from "@/assets/reset-password/forgot-password-image.svg";

export const Route = createFileRoute("/reset-password/")({
  component: ResetPassword,
});

function ResetPassword() {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-5 min-h-screen">
      {/* Image */}
      <div className="grid col-span-2 bg-beige self-center">
        <div className="flex flex-col gap-4 items-center">
          <img
            src={forgotPasswordImg}
            alt={t("reset_password.img_alt")}
            className="w-3/5 h-auto"
          />
          <div className="flex flex-col gap-4 text-center mx-8">
            <HeadingTwo>{t("reset_password.msg_title")}</HeadingTwo>
            <Paragraph>{t("reset_password.msg_text")}</Paragraph>
          </div>
        </div>
      </div>

      {/* Email validation Form */}
      <div
        className={`grid col-span-3 ${bgLinearGradient} border-l-1 border-neutral-500`}
      >
        <div className="flex flex-col my-auto">
          <div className="mx-auto mb-14">
            <MimiatHorizontalLogo />
          </div>
          <div className="mx-24 2xl:min-w-[575px] 2xl:mx-auto">
            <div className="flex flex-col gap-2 mb-4">
              <HeadingOne>{t("reset_password.title")}</HeadingOne>
              <Paragraph>{t("reset_password.subtitle")}</Paragraph>
            </div>
            <EmailInput />
          </div>
        </div>
      </div>
    </div>
  );
}
